import { createAsyncTypes } from 'utils/ActionCreator'

// Icons kept for backward compatibility with other components that may use SORTING_OPTIONS
import { Calendar, Emails, Incident, Mail } from 'components/lib/DesignSystem/Icons'

export const COMPANIES_REQUEST_ASYNC = createAsyncTypes(
  'COMPANIES_REQUEST',
  'ResolutionCenter/TopBar'
)

export const SEARCH_CHANGE = 'ResolutionCenter/TopBar/SEARCH_CHANGE'
export const SEARCH_RESET = 'ResolutionCenter/TopBar/SEARCH_RESET'

export const SORTING_FILTER_CHANGE = 'ResolutionCenter/TopBar/SORTING_FILTER_CHANGE'
export const SORTING_FILTER_RESET = 'ResolutionCenter/TopBar/SORTING_FILTER_RESET'
export const GENERAL_FILTER_CHANGE = 'ResolutionCenter/TopBar/GENERAL_FILTER_CHANGE'
export const CHALLENGED_TYPE_FILTER_CHANGE = 'ResolutionCenter/TopBar/CHALLENGED_TYPE_FILTER_CHANGE'

export const SORTING_OPTIONS = [
  {
    value: 'date',
    label: 'Creation date',
    Icon: Calendar,
    id: 'CreationDate',
  },
  {
    value: 'latest_email_date',
    label: 'Last message sent',
    Icon: Incident,
    id: 'LastEmailAdded',
  },
  {
    value: 'cluster_size',
    label: 'Number of affected emails',
    Icon: Emails,
    id: 'ClusterSize',
  },
  {
    value: 'priority',
    label: 'Priority',
    Icon: Mail,
    id: 'Priority',
  },
]

export const DEFAULT_SORTING_OPTION = {
  unclassifiedSortingBy: 'priority',
  classifiedSortingBy: 'date',
}
/**
 * Tab default sort key in DEFAULT_SORTING_OPTION / localStorage.
 * Classified is always date. Challenged is date only on the incidents redesign
 * (legacy Challenged has no sort UI and historically sent unclassified `priority`).
 */
export const getLocalStorageIncidentsSortingKey = (urlState, { incidentsRedesign = false } = {}) =>
  urlState === 'classified' || (incidentsRedesign && urlState === 'challenged')
    ? 'classifiedSortingBy'
    : 'unclassifiedSortingBy'
